import { render, staticRenderFns } from "./CompanyDetailPage.vue?vue&type=template&id=861555dc&scoped=true"
import script from "./CompanyDetailPage.vue?vue&type=script&lang=js"
export * from "./CompanyDetailPage.vue?vue&type=script&lang=js"
import style0 from "./CompanyDetailPage.vue?vue&type=style&index=0&id=861555dc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "861555dc",
  null
  
)

export default component.exports